import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsScrolling } from 'tradera/hooks/use-is-scrolling';
import cn from 'classnames';
import styles from './floating-action-button.module.scss';

type FloatingActionButtonProps = {
    isHidden?: boolean;
    hideOnScroll?: boolean;
    className?: string;
    shadow?: boolean;
    children: React.ReactNode;
};

const FloatingActionButton = ({
    isHidden,
    hideOnScroll = true,
    className,
    shadow,
    children
}: FloatingActionButtonProps) => {
    const ref = useRef(null);

    const isScrolling = useIsScrolling(hideOnScroll ? 250 : 0);

    const hide = isHidden || isScrolling;

    const stickyButtonClass = cn(styles.floatingActionButton, className, {
        [styles.hide]: hide,
        shadow: shadow
    });

    return (
        <div ref={ref} className={stickyButtonClass} aria-hidden={hide}>
            {children}
        </div>
    );
};

export const FloatingActionButtonPortal = (
    props: FloatingActionButtonProps
) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);

    const element = isMounted
        ? document.body.querySelector('#floating-action-button-portal')
        : null;
    if (element) {
        return createPortal(<FloatingActionButton {...props} />, element);
    } else {
        return null;
    }
};
